import { render, staticRenderFns } from "./PasswordEdit.vue?vue&type=template&id=d49020d8&"
import script from "./PasswordEdit.vue?vue&type=script&lang=js&"
export * from "./PasswordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports